module.exports = __webpack_public_path__ + "img/tutorial_two_nl.b02ddc1e.png";